import { render } from "./NextPanel.vue?vue&type=template&id=1b86c86f"
import script from "./NextPanel.vue?vue&type=script&lang=js"
export * from "./NextPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__